export default __webpack_public_path__ + "static/media/remove-circle.a3ebacc5.svg";